<script setup lang="ts">
interface Props {
  isLoading?: boolean;
  size?: 'sm' | 'md' | 'square';
  color?: 'default' | 'error' | 'success' | 'warning';
}

withDefaults(defineProps<Props>(), {
  size: 'md',
  color: 'default',
});

const slots = defineSlots<{
  leading(): void;
  default(): void;
  trailing(): void;
}>();
</script>

<template>
  <button
    class="flex items-center justify-center whitespace-nowrap rounded-md bg-white font-medium text-brand-primary ring-1 ring-inset ring-brand-primary transition-all hover:bg-brand-primary-soft disabled:cursor-not-allowed disabled:bg-white disabled:text-semantic-text-secondary disabled:ring-semantic-border-primary"
    :class="{
      'pointer-events-none': isLoading,
      'h-10 px-4': size === 'md',
      'h-8 px-3 text-sm': size === 'sm',
      'h-8 px-2': size === 'square',
      'text-system-error-red ring-system-error-red hover:bg-system-error-light': color === 'error',
      'text-system-success-green ring-system-success-green hover:bg-system-success-light':
        color === 'success',
      'text-system-warning-yellow ring-system-warning-yellow hover:bg-system-warning-light':
        color === 'warning',
    }"
  >
    <span v-if="!!slots.leading && !isLoading" class="mr-2 inline-block">
      <slot name="leading"></slot>
    </span>

    <slot v-if="!isLoading" name="default"></slot>

    <IconifyIcon v-if="isLoading" icon="formkit:spinner" class="size-6 animate-spin"></IconifyIcon>

    <span v-if="!!slots.trailing && !isLoading" class="ml-2 inline-block">
      <slot name="trailing"></slot>
    </span>
  </button>
</template>

<style scoped lang="scss"></style>
